import { render, staticRenderFns } from "./CurrencySummary.vue?vue&type=template&id=deae24e8&scoped=true&"
import script from "./CurrencySummary.vue?vue&type=script&setup=true&lang=js&"
export * from "./CurrencySummary.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CurrencySummary.vue?vue&type=style&index=0&id=deae24e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae24e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VDataTable,VDivider,VIcon,VRow})
